import React from 'react';
import { DatePicker, Button, Space } from 'antd';
import { ReloadOutlined, CalendarOutlined } from '@ant-design/icons';
import dayjs, { Dayjs } from 'dayjs';

interface PaymentHeaderProps {
  selectedDate: Dayjs;
  onDateChange: (date: Dayjs | null) => void;
  onRefresh: () => void;
  loading: boolean;
}

const PaymentHeader: React.FC<PaymentHeaderProps> = ({
  selectedDate,
  onDateChange,
  onRefresh,
  loading,
}) => {
  return (
    <div className="bg-white p-4 rounded-lg shadow-sm border">
      <div className="flex justify-between items-center">
        <div className="flex items-center space-x-4">
          <CalendarOutlined className="text-blue-500 text-lg" />
          <h1 className="text-xl font-semibold text-gray-800">
            Thanh toán kỳ đáo hạn
          </h1>
          <div className="flex items-center space-x-2">
            <span className="text-sm font-medium text-gray-600">
              Chọn ngày:
            </span>
            <DatePicker
              value={selectedDate}
              onChange={onDateChange}
              format="DD/MM/YYYY"
              allowClear={false}
              className="w-32"
              placeholder="Chọn ngày"
            />
          </div>
        </div>
        <Button
          type="primary"
          icon={<ReloadOutlined />}
          onClick={onRefresh}
          loading={loading}
          className="flex items-center"
        >
          Tải lại
        </Button>
      </div>
    </div>
  );
};

export default PaymentHeader;
